import { BlobServiceClient } from "@azure/storage-blob";

export const moveBlobInStorage = async (
  originalUrl: string,
  newFolder: string,
  sasToken: string | null,
  azureBlobStorageConfig: {
    accountName: string
    containerName: string
  }
): Promise<string | null> => {
  try {
    const { accountName, containerName } = azureBlobStorageConfig
    const blobServiceClient = new BlobServiceClient(
      `https://${accountName}.blob.core.windows.net/?${sasToken}`
    )
    const containerClient = blobServiceClient.getContainerClient(containerName)

    const originalUri = new URL(originalUrl)
    const originalPath = originalUri.pathname.split("/").slice(2).join("/")
    const fileName = originalPath.split("/").pop()!
    const newBlobPath = `${newFolder}/${fileName}`

    const sourceBlob = containerClient.getBlobClient(originalPath)
    const targetBlob = containerClient.getBlobClient(newBlobPath)

    // Copy the blob
    const copyPoller = await targetBlob.beginCopyFromURL(sourceBlob.url)
    await copyPoller.pollUntilDone()

    // Delete the old blob after successful copy
    await sourceBlob.deleteIfExists()

    // Return new URL
    return targetBlob.url
  } catch (error) {
    console.error("Failed to move blob:", error)
    return null
  }
}




